import {
    SilSafetyFunction,
    SilResultSafetyFunction,
} from "server/models"

export type SilResultSafetyFunctionList = { [safetyFunctionId: number]: SilResultSafetyFunction }

export interface SilResultSafetyFunctionState {
    safetyFunctionList: SilSafetyFunction[]
    calculatedSafetyFunctionList: SilResultSafetyFunctionList
    updatedDevices: number

    reloadList: boolean
}

export const SIL_RESULT_SAFETY_FUNCTION_LIST = "SIL_RESULT_SAFETY_FUNCTION_LIST"
export const SIL_RESULT_CALCULATED_SAFETY_FUNCTION = "SIL_RESULT_CALCULATED_SAFETY_FUNCTION"
export const SIL_RESULT_UPDATED_DEVICES = "SIL_RESULT_UPDATED_DEVICES"

export const SIL_RESULT_RELOAD_LIST = "SIL_RESULT_RELOAD_LIST"
